export enum UserRoleEnum {
  district_admin = "district_admin",
  school_admin = "school_admin",
  teacher = "teacher",
  parent = "parent",
  student = "student",
}

// Ranking from the highest role level
export const ROLE_RANKING = [
  UserRoleEnum.district_admin,
  UserRoleEnum.school_admin,
  UserRoleEnum.teacher,
  UserRoleEnum.parent,
  UserRoleEnum.student,
];
